function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecoveryX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-bullseye",
    d: "M20 .563a20 20 0 1 0 20 20 20 20 0 0 0-20-20zM20 35.4a14.839 14.839 0 1 1 14.839-14.837A14.83 14.83 0 0 1 20 35.4zm0-25.16a10.323 10.323 0 1 0 10.323 10.323A10.323 10.323 0 0 0 20 10.24zm0 15.484a5.161 5.161 0 1 1 5.161-5.161A5.167 5.167 0 0 1 20 25.724z",
    transform: "translate(0 -.563)",
    style: {
      fill: "#346ac3"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoveryX);
export default __webpack_public_path__ + "static/media/recoveryX.866eabce410cf4dd2ca5de064af032b7.svg";
export { ForwardRef as ReactComponent };